function monetize(value, currency) {
  if (value == null || !currency) return value
  return new Intl.NumberFormat(navigator.language, { style: 'currency', currency }).format(value)
}

function striptags(value) {
  if (!value) return value
  return value.replace(/<br>/g, ' ').replace(/<[^>]*>/g, '')
}

function decodeUri(value) {
  if (!value) return value
  return window.decodeURI(value)
}

const FiltersPlugin = {
  install(Vue) {
    Vue.filter('monetize', monetize)
    Vue.filter('striptags', striptags)
    Vue.filter('decodeUri', decodeUri)
    Object.defineProperties(Vue.prototype, {
      $filters: { get() { return { monetize, striptags, decodeUri } } }
    })
  }
}

export default FiltersPlugin
